/**
 * Builds a human-readable, URL-safe slug for a pod from its name and id.
 *
 * The trailing suffix is a short fragment of the pod's id (not the full GUID),
 * kept only to guarantee uniqueness between pods that share the same name for
 * a given user. It intentionally never exposes the full underlying id in the
 * browser URL.
 *
 * This function is pure and deterministic: given the same name + id it always
 * produces the same slug, so callers that only have `id`/`name` (e.g. PodBadge)
 * can build a matching link without needing the full pod object.
 */
export function buildPodSlug(name: string | undefined | null, id: string): string {
  const base = (name ?? '')
    .toLowerCase()
    .trim()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const suffix = id.replace(/-/g, '').slice(-8).toLowerCase() || 'pod';

  return base ? `${base}-${suffix}` : suffix;
}
